import { Children, type FC, type ReactNode } from "react";
import MyAccountRegistered from "./components/MyAccountRegistered/MyAccountRegistered";
import { userIsLoggedIn, userIsRegistered } from "../utils/roles";
import MyAccountB2B from "./components/MyAccountB2B/MyAccountB2B";
import { type MyAccountDataJSP } from "./myAccountTypes";
import { transformMyAccountData } from "./myAccountDataTransformers";
import classNames from "classnames";

export function createMyAccount(data: MyAccountDataJSP) {
  return <MyAccountContainer {...data} />;
}

export const MyAccountContainer = (dataDto: MyAccountDataJSP) => {
  const loggedIn = userIsLoggedIn();
  const registeredUser = userIsRegistered();

  const data = transformMyAccountData(dataDto);

  return <>{loggedIn && <>{registeredUser ? <MyAccountRegistered data={data} /> : <MyAccountB2B data={data} />}</>}</>;
};

interface FormSectionProps extends Omit<JSX.IntrinsicElements["div"], "title"> {
  title?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const FormSection: FC<FormSectionProps> = ({ children, title, className, ...rest }) => {
  return (
    <div className={classNames("scha__my-account-form__section", className)} {...rest}>
      {title && <h3 className={"scha__my-account-form__section__title"}>{title}</h3>}
      {Children.map(children, (child) => child && <div className="scha__my-account-form__field">{child}</div>)}
    </div>
  );
};
